import ShCard from '@/components/Helpers/ShCard';

export default {
  name: 'PermissionProfilesCategoryItem',

  components: {
    ShCard,
  },

  props: {
    name: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    slug: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isPermissionActive: false,
    };
  },

  created() {
    this.isPermissionActive = this.isActive;
  },
};
